<template>
  <VendorBlock
    class="vendor-achievements"
  >
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <div class="vendor-achievements__content">
        <ul class="vendor-achievements__list">
          <li
            v-for="(card, i) in slicedCards"
            :key="i"
            class="vendor-achievements__item"
          >
            <UiAchievementCard
              :card="card"
              class="vendor-achievements__card"
            />
          </li>
        </ul>

        <UiButton
          v-if="achievements.length > 2"
          theme="quaternary"
          size="big"
          stretch
          @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
        </UiButton>
      </div>
    </template>
  </VendorBlock>
</template>

<script setup lang="ts">
  import UiAchievementCard from '@academica-box/components/Cards/UiAchievementCard/UiAchievementCard.vue'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import type { AchievementCard } from '@academica-box/components/Cards/UiAchievementCard/types'
  import VendorBlock from '@/components/Vendor/VendorBlock.vue'

  const props = defineProps<{
    title: string;
    achievements: AchievementCard[];
  }>()

  const isExpanded = ref(false)

  const slicedCards = computed(() => {
    return isExpanded.value ? props.achievements : [...props.achievements].splice(0, 2)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiReset' as *;

  .vendor-achievements__list {
    @include ulres;

    margin-bottom: 20px;

    @include media(md) {
      display: grid;
      grid-gap: 6px;
      grid-template-columns: 1fr 1fr;
    }

    @include media(lg) {
      margin-bottom: 32px;
    }

    @include media(lg, xl-max) {
      display: block;
    }
  }

  .vendor-achievements__item {
    &:not(:last-child) {
      @include media(sm-max) {
        margin-bottom: 6px;
      }

      @include media(lg, xl-max) {
        margin-bottom: 6px;
      }
    }
  }

  .vendor-achievements__card {
    height: 100%;
  }
</style>
